export const FILE_TYPE = {
  DIRECTORY: 'directory',
  FILE: 'file',
};
